import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editBrandingSetup } from '@api/managePlatformBranding';

import { IEditBrandingSetupsDTO } from '@interfaces/platform/dto/brandingDTO';

import { ESnackbarTypes } from '@enums/common';

import { BRANDING_SETUPS, EDIT_BRANDING_SETUP } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IEditSetupReturnType {
	handleEditBrandingSetup: ({ setupId, dto }: IEditBrandingSetupsDTO) => void;
	isLoadingEditBrandingSetup: boolean;
}

export const useMutateEditBrandingSetup = (onSettledCallbacks?: Array<() => void>): IEditSetupReturnType => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: handleEditBrandingSetup,
		isLoading: isLoadingEditBrandingSetup,
	} = useMutation<IEditBrandingSetupsDTO>({
		mutationKey: [EDIT_BRANDING_SETUP],
		mutationFn: editBrandingSetup,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.editBrandingSetup,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([BRANDING_SETUPS]);
		},
	});

	return {
		handleEditBrandingSetup,
		isLoadingEditBrandingSetup,
	};
};
